import {
  DrawerProps as MantineDrawerProps,
  Drawer as MantineDrawer,
  DrawerRootProps as MantineDrawerRootProps,
  DrawerRoot as MantineDrawerRoot,
  DrawerOverlayProps as MantineDrawerOverlayProps,
  DrawerOverlay as MantineDrawerOverlay,
  DrawerContentProps as MantineDrawerContentProps,
  DrawerContent as MantineDrawerContent,
  DrawerBodyProps as MantineDrawerBodyProps,
  DrawerBody as MantineDrawerBody,
  DrawerHeaderProps as MantineDrawerHeaderProps,
  DrawerHeader as MantineDrawerHeader,
  DrawerTitleProps as MantineDrawerTitleProps,
  DrawerTitle as MantineDrawerTitle,
  DrawerCloseButtonProps as MantineDrawerCloseButtonProps,
  DrawerCloseButton as MantineDrawerCloseButton,
} from '@mantine/core';

export type DrawerProps = MantineDrawerProps;
export type DrawerRootProps = MantineDrawerRootProps;
export type DrawerOverlayProps = MantineDrawerOverlayProps;
export type DrawerContentProps = MantineDrawerContentProps;
export type DrawerBodyProps = MantineDrawerBodyProps;
export type DrawerHeaderProps = MantineDrawerHeaderProps;
export type DrawerTitleProps = MantineDrawerTitleProps;
export type DrawerCloseButtonProps = MantineDrawerCloseButtonProps;

export const Drawer = MantineDrawer;
Drawer.displayName = 'Drawer';

export const DrawerRoot = MantineDrawerRoot;
DrawerRoot.displayName = 'DrawerRoot';

export const DrawerOverlay = MantineDrawerOverlay;
DrawerOverlay.displayName = 'DrawerOverlay';

export const DrawerContent = MantineDrawerContent;
DrawerContent.displayName = 'DrawerContent';

export const DrawerBody = MantineDrawerBody;
DrawerBody.displayName = 'DrawerBody';

export const DrawerHeader = MantineDrawerHeader;
DrawerHeader.displayName = 'DrawerHeader';

export const DrawerTitle = MantineDrawerTitle;
DrawerTitle.displayName = 'DrawerTitle';

export const DrawerCloseButton = MantineDrawerCloseButton;
DrawerCloseButton.displayName = 'DrawerCloseButton';
